module.exports = __webpack_public_path__ + "img/intuit.7771c3c8.png";